import { AxiosResponse } from 'axios';
import { SET_FILES, SET_FILE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_FILE_ISLOADING,
  DELETE_FILE,
  EDIT_FILE,
  GET_FILES,
  GET_FILE,
  REGISTER_FILE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import File from '@/services/file';
import { Module } from 'vuex';
import { EditFile, RegisterFile, GetFile } from '@/dtos/file.dto';

const file: Module<any, {}> = {
  state: {
    file: {
      data: null,
      isLoading: false,
    },
    files: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    file: (state: { file: any }) => state.file,
    files: (state: { files: any }) => state.files,
  },
  mutations: {
    [SET_FILE]: (
      state: { file: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.file.data = payload.data) : null,
        (state.file.isLoading = payload.isLoading);
    },
    [SET_FILES]: (
      state: { files: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.files.data = payload.data) : null,
        (state.files.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_FILE]: async ({ commit }: any, payload: FormData) => {
      commit(SET_FILE, { data: null, isLoading: true });

      const result: AxiosResponse = await File.registerFile(
        payload
      );

      if (result) {
        if (result.data.status) {
          commit(SET_FILE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_FILE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FILE, { isLoading: false });
        return false;
      }
    },
    [GET_FILES]: async ({ commit }: any, payload: any) => {
      commit(SET_FILES, { data: null, isLoading: true });

      const result: AxiosResponse = await File.getFiles(
        payload as GetFile
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_FILES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_FILES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FILES, { isLoading: false });
        return false;
      }
    },
    [GET_FILE]: async ({ commit }: any, payload: any) => {
      commit(SET_FILES, { data: null, isLoading: true });

      const result: AxiosResponse = await File.getFiles(
        payload as GetFile
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_FILES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_FILES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FILES, { isLoading: false });
        return false;
      }
    },
    [EDIT_FILE]: async ({ commit }: any, payload: FormData) => {
      commit(SET_FILE, { data: null, isLoading: true });

      const result: AxiosResponse = await File.editFile(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_FILE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_FILE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FILE, { isLoading: false });
        return false;
      }
    },
    [DELETE_FILE]: async ({ commit }: any, payload: string) => {
      commit(SET_FILE, { data: null, isLoading: true });

      const result: AxiosResponse = await File.deleteFile(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_FILE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_FILE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FILE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_FILE_ISLOADING]: ({ commit }) => {
      commit(SET_FILE, { isLoading: false });
      commit(SET_FILES, { isLoading: false });
    },
  },
};

export default file;
